import { createFileRoute } from "@tanstack/react-router";

import { RequireAuth } from "../../features/auth/RequireAuth";
import { NotificationDetailPage } from "../../features/notifications/NotificationDetailPage";

// The push click's destination (see notification-target.ts). Behind the auth
// gate, which renders sign-in in place, so the deep link survives a sign-in.
export const Route = createFileRoute("/notifications/$notificationId")({
  component: RouteComponent,
});

function RouteComponent() {
  const { notificationId } = Route.useParams();
  return (
    <RequireAuth>
      {(user) => (
        <NotificationDetailPage
          uid={user.uid}
          notificationId={notificationId}
          email={user.email}
          signOut={user.signOut}
        />
      )}
    </RequireAuth>
  );
}
